<homey-page-title title="My data"/>

<p class="mt-4">
  Homey does everything possible to protect your data. Most importantly, we do not share any of it, outside of what is strictly necessary to submit Housing Lottery applications.
</p>

<p class="mt-4">
  If you want your Homey account, the Housing Connect account we've created for you and all of your personal data to be deleted, please use the button below.
</p>

<p-button
  class="mt-auto"
  severity="contrast"
  styleClass="w-full"
  (onClick)="onDeleteClick()">Request account deletion</p-button>
